import styled from "styled-components";
import { capitalizeFirstLetter } from "../../utils/formatters";
import React from "react";
import { getQuerystringParams } from "../../utils/miscellaneous";
import { useNavigationManager } from "../../hooks/useNavigationManager";
// import { ROUTES } from "../../../router";

const Container = styled.div`
  a,
  p {
    font-family: var(--font-paragraph-default);
    font-size: 16px;
  }

  a {
    color: var(--color-text-labels);
    cursor: pointer;
  }

  p {
    display: inline;
    cursor: default;
    color: var(--color-text-paragraph);
  }
`;

type TBreadCrumbsProps = {
  names: string[];
  urls: string[];
};

const BreadCrumbs: React.FC<TBreadCrumbsProps> = ({ names, urls }) => {
  const { setQuerystring, goTo } = useNavigationManager();
  const querystring = getQuerystringParams();


  return (
    <Container>
      <span>
        {names.map((path, index) => (
          <React.Fragment key={index}>
            {index === names.length - 1 ? (
              <p>{capitalizeFirstLetter(path)}</p>
            ) : (
              <>
                <a
                  // href={urls[index] + querystring}
                  onClick={(e) => {
                    e.preventDefault();
                    const qsCopy = {...querystring};

                    if (querystring.search) {
                      delete qsCopy.search;
                    }
                    if (querystring.page) {
                      qsCopy.page = 1;
                    }
                    setQuerystring(qsCopy);
                    goTo(urls[index], qsCopy);
                  }}
                >
                  {capitalizeFirstLetter(path)}
                  {" > "}
                </a>
              </>
            )}
          </React.Fragment>
        ))}
      </span>
    </Container>
  );
};

export default BreadCrumbs;
